import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { getUser } from "../../../services/local_service.js";
import axios from "axios";
import beveatApiResourceOwner from "../../../api/resource_owner_beveat_api.js";
import { useEffect, useState } from "react";
import { urls, commonConfigs } from "../../../../config.js";
import CreateCertificateDetailsModal from "../../../views/plans/components/create_certificate_details_modal.jsx";
import { INVOICE_PLAN_SYSCODE, InvoicePlanSyscodeString } from "../../../constants/invoice_plan_syscode.jsx";
import { DEVELOPER_PROJ_STATUS } from "../../../constants/developer_proj_status.jsx";
import { doublewriteConfig } from "../../../../config.js";
import ComingSoonModal from "../../../views/components/coming_soon_modal.jsx";
import { pricingPlanCurrentTabContext } from '../../../views/plans/context/pricing_plan_context.jsx';
import { INVOICE_SYSCODE } from "../../../constants/invoice_syscode.jsx";

export default function ProjectApiCatalogueCard({
    industry,
    plan,
    price,
    planId,
    benefits,
    onButtonClick,
    buttonLabel,
    handleComingSoonClick,
}) {
    const { currentTab } = useContext(pricingPlanCurrentTabContext);
    const [load, setLoad] = useState(true);
    const [certificates, setCertificates] = useState([]);
    const [isOpen, setOpen] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [project, setProject] = useState();
    // const [invoicePlanSyscode, setInvoicePlanSyscode] = useState(null);
    const navigate = useNavigate();
    const ssoId = getUser()?.sso_id;
    const accountId = getUser()?.account_id;
    const getDeveloperCertificatesUrl =
        urls.resourceOwnerUrl +
        commonConfigs.apiUrls.getAllDeveloperCertificates(accountId);
    const devProjTableSyscode = currentTab.invoicePlanSyscode;
    async function getDeveloperProjectByPlan(planId) {
        const getDeveloperProjectByPlanUrl =
            urls.resourceOwnerUrl +
            commonConfigs.apiUrls.getDeveloperProjectByPlan(ssoId, planId);
        await beveatApiResourceOwner
            .get(getDeveloperProjectByPlanUrl, {
                headers: commonConfigs.resourceOwnerApiHeader,
            })
            .then(async (res) => {
                if (res.data.result.data) {
                    setProject(res.data.result.data);
                    if (
                        res.data.result.data.developer_proj_status ===
                        DEVELOPER_PROJ_STATUS.Active
                    ) {
                        await getDeveloperCourse(
                            planId,
                            res.data.result.data.developer_proj_id
                        );
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    async function updateDoublewriteDevProj(projId) {
        const { url, headers } = doublewriteConfig(process.env.REACT_APP_ENV);
        const doublewriteUrl =
            url + commonConfigs.apiUrls.UpdateDeveloperProject(projId, devProjTableSyscode);
        const body = {
            developer_proj_status: DEVELOPER_PROJ_STATUS.Expired,
        };
        try {
            await beveatApiResourceOwner.put(doublewriteUrl, body, { headers: headers });
        } catch (error) {
            console.error("Error updating doublewrite project:", error);
        }
    }

    async function updateDeveloperProj(projId) {
        const updateProjUrl =
            urls.resourceOwnerUrl +
            commonConfigs.apiUrls.UpdateDeveloperProject(projId, devProjTableSyscode);
        const body = {
            developer_proj_status: DEVELOPER_PROJ_STATUS.Expired,
        };
        try {
            await beveatApiResourceOwner.put(updateProjUrl, body, {
                headers: commonConfigs.resourceOwnerApiHeader,
            });
        } catch (error) {
            console.error("Error updating doublewrite project:", error);
        }
    }

    async function getDeveloperCourse(planId, projId) {
        const getDeveloperCourseUrl =
            urls.resourceOwnerUrl +
            commonConfigs.apiUrls.getDeveloperCourses(accountId, planId, 0);
        await beveatApiResourceOwner
            .get(getDeveloperCourseUrl, {
                headers: commonConfigs.resourceOwnerApiHeader,
            })
            .then(async (res) => {
                // console.log(res.data.result.data);
                if (Object.keys(res.data.result.data).length !== 0) {
                    // If course found, show details
                    setShowDetails(true);
                } else {
                    // Project expired
                    await updateDeveloperProj(projId);
                    await updateDoublewriteDevProj(projId);
                }
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }

    async function getDeveloperCertificates() {
        await beveatApiResourceOwner
            .get(getDeveloperCertificatesUrl, {
                headers: commonConfigs.resourceOwnerApiHeader,
            })
            .then((res) => {
                // console.log(res.data.result.data);
                setCertificates(res.data.result.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    useEffect(() => {
        getDeveloperCertificates().catch((err) => {
            console.log("err for getting developer certificates: " + err);
        });
        // if (currentTab.name === "Certification (UAT)") {
        //   const isGoLive =
        //     plan.certification_category.includes("Go Live");
        //   invoicePlanSyscode = isGoLive
        //     ? INVOICE_PLAN_SYSCODE.Certification_Plan_Go_Live
        //     : INVOICE_PLAN_SYSCODE.Certification_Plan_UAT;
        // } else {
        //   const isProduction = currentTab.name !== "Staging";
        //   environment = isProduction
        //     ? { value: "1", label: "Production" }
        //     : { value: "0", label: "Staging" };
        //   invoicePlanSyscode = isProduction
        //     ? INVOICE_PLAN_SYSCODE.API_Plan_Go_Live
        //     : INVOICE_PLAN_SYSCODE.API_Plan_UAT;
        // }

        getDeveloperProjectByPlan(planId).catch((err) => {
            console.log("err for getting inactiveDevProject: " + err);
        });
        // setInvoicePlanSyscode(invoiceSyscode);
        setLoad(false);
    }, []);

    const onGetCertificateClick = () => {
        const developerCertificate = certificates.find(
            (certificate) =>
                certificate.org_invoice_plan_id == planId &&
                certificate.developer_proj_id == project.developer_proj_id
        );
        if (developerCertificate) {
            navigate("/certification", {
                state: {
                    planName: plan.invoice_plan,
                    certificationPlanId: planId,
                    environment: InvoicePlanSyscodeString[currentTab.invoicePlanSyscode],
                    devProjId: project.developer_proj_id,
                },
            });
        } else {
            setOpen(true);
        }
    };
    if (!load) {
        return (
            <>
                <div className="bg-white shadow-lg rounded-xl w-90 h-[25rem] flex flex-col justify-between">
                    <div className="p-6 text-black">
                        {/* <h2 className="text-gray-700 font-bold mb-2" style={{ fontSize: "25px" }}>
                            Industry123
                        </h2> */}
                        <div className="bg-blue-400 text-white font-bold text-lg py-1 mb-2 rounded-full">
                            {industry}
                        </div>
                        <p className="text-3xl font-bold text-gray-800 mb-1" >
                            <span>${price}</span>
                        </p>

                        {/* <p className="text-red-600 text-sm">with Course Code</p> */}

                        <ul
                            className="text-left"
                            style={{ listStyleType: "circle", paddingLeft: "20px", marginTop: "24px" }}
                        >
                            {benefits.map((benefit, index) => {
                                if (typeof benefit === "string") {
                                    return (
                                        <li key={index} className="mb-2">
                                            {benefit}
                                        </li>
                                    );
                                } else if (typeof benefit === "object" && benefit.title && benefit.children) {
                                    return (
                                        <li key={index} className="mb-2">
                                            {benefit.title}
                                            <ul style={{ paddingLeft: "20px", listStyleType: "circle" }}>
                                                {benefit.children.map((child, childIndex) => (
                                                    <li key={childIndex} className="mb-2">
                                                        {child}
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                    );
                                }
                                return null;
                            })}
                        </ul>
                    </div>
                    <div>
                        {/* {showDetails ? (
                            <div className="flex border-t border-white">
                                <Link
                                    to={`/projects/details`}
                                    className="flex-1 bg-blue-400 text-white py-3 font-semibold hover:bg-blue-600"
                                    state={{
                                        developerSsoId: ssoId,
                                        developerProjId: project.developer_proj_id,
                                        environment: "staging",
                                    }}
                                >
                                    <button>View Project Details</button>
                                </Link>
                                <div className="w-[1px] bg-white"></div>
                                <button
                                    onClick={onGetCertificateClick}
                                    className="flex-1 bg-blue-400 text-white py-3 font-semibold hover:bg-blue-600"
                                >
                                    Get Course Certificate
                                </button>
                            </div>
                        ) : ( */}
                        <button
                            // onClick={() => handleComingSoonClick("End June")}
                            // className="bg-gray-400 hover:bg-blue-600 text-white py-3 px-4 w-full font-semibold"
                            onClick={onButtonClick}
                            className="bg-blue-400 hover:bg-blue-600 text-white py-3 px-4 w-full font-semibold"
                        >
                            Get Certified
                        </button>
                        {/* )} */}
                    </div>
                    {isOpen && (
                        <CreateCertificateDetailsModal
                            setOpenModal={setOpen}
                            // invoicePlanSyscode={invoicePlanSyscode}
                            planName={plan.invoice_plan_category}
                            planId={planId}
                            devProjId={project.developer_proj_id}
                            environment={InvoicePlanSyscodeString[currentTab.invoicePlanSyscode]}
                        />
                    )}
                </div>
            </>
        );
    }
}
